import React from 'react';

class Error extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <section className="error">
        <div className="container">
          <h1>Nosso site está em manutenção</h1>
          <p className="complement">Mas fique tranquilo, você pode continuar concorrendo ao prêmio por <b>SMS</b>.</p>
          <h2>Como funciona?</h2>
          <p>É muito simples participar, basta seguir os próximos passos:</p>
          <ul>
            <li><span>Envie um SMS com a palavra <b>ATIVE</b> para <b>7979</b> e assine o Jogada Musical.</span></li>
            <li><span>Após a assinatura, você receberá as 5 perguntas da sua <b>Rodada do Dia</b>.</span></li>
            <li><span>Responda <b>3 perguntas</b> e receba seu cupom diário para concorrer ao prêmio!</span></li>
          </ul>
        </div>
      </section>
    );
  }
}

export default Error;


// WEBPACK FOOTER //
// ./src/components/pages/error.component.jsx